module.exports = __webpack_public_path__ + "logo.png?1b169878fba16a3da866f636566b35d3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 379
// module chunks = 0